var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 72,
    viewBox: "0 0 108 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_504_4)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.1888 55.9977C47.7721 56.1458 50.8177 49.1843 67.5683 51.406C80.8927 53.1834 86.2986 44.5186 87.7452 39.2604C88.4305 36.7424 88.202 26.9667 80.9688 27.1148C56.2997 27.5591 35.4376 2.97167 24.4735 25.5596C19.9052 34.7428 13.2049 55.7755 37.1888 55.9977Z",
    fill: "#B198F8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_504_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 10.6335L34 58.3665C34 60.3732 35.9425 62 38.3388 62L69.6612 62C72.0575 62 74 60.3732 74 58.3665L74 10.6335C74 8.62676 72.0575 7 69.6612 7L38.3388 7C35.9425 7 34 8.62677 34 10.6335Z",
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 13,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#FFD77C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 49,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#FFD77C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 23,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#FFD77C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 28,
    width: 30,
    height: 19,
    rx: 1,
    fill: "#FFFAF0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 18,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#FFD77C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 54,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#FFD77C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2165 43C48.5375 43 48 42.434 48 41.7518V34.2482C48 33.5515 48.5517 33 49.2165 33H59.7835C60.4625 33 61 33.566 61 34.2482V41.7518C61 42.4485 60.4483 43 59.7835 43H49.2165ZM49.4146 35.9173C49.4146 36.73 50.0511 37.3832 50.8292 37.3832C51.6072 37.3832 52.2579 36.73 52.2579 35.9173C52.2579 35.1045 51.6213 34.4659 50.8292 34.4659C50.037 34.4659 49.4146 35.119 49.4146 35.9173ZM59.3732 41.3309V38.4136L57.1523 36.135C57.0392 36.0189 56.8411 36.0189 56.728 36.135L53.2905 39.6618L51.876 38.2105C51.7628 38.0943 51.5647 38.0943 51.4516 38.2105L49.6409 40.0682V41.3164H59.3874L59.3732 41.3309Z",
    fill: "#FFB500"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_504_4",
    x: 20,
    y: -7,
    width: 68,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0666667 0 0 0 0 0.309804 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_504_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_504_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.d2dc1a526f51331776b27e4fcfa61e6e.svg";
export { ForwardRef as ReactComponent };